import { z } from 'zod';
import { boardSchema } from './board';
import { ulidSchema } from './id';

export const BOARD_SNAPSHOT_RETENTION_DAYS_DEFAULT = 30;

const timestampSchema = z.string().min(1).max(64);

export const boardSnapshotSchema = z.strictObject({
  id: ulidSchema,
  boardId: ulidSchema,
  takenAt: timestampSchema,
  expiresAt: timestampSchema,
});

export type BoardSnapshot = z.infer<typeof boardSnapshotSchema>;

export const boardSnapshotListSchema = z.strictObject({
  boardId: ulidSchema,
  enabled: z.boolean(),
  retentionDays: z.number().int().positive(),
  captureAttachments: z.boolean(),
  snapshots: z.array(boardSnapshotSchema),
});

export type BoardSnapshotList = z.infer<typeof boardSnapshotListSchema>;

export const boardSnapshotEnabledPatchSchema = z.strictObject({
  enabled: z.boolean(),
});

export type BoardSnapshotEnabledPatch = z.infer<typeof boardSnapshotEnabledPatchSchema>;

export const boardSnapshotRetentionPatchSchema = z.strictObject({
  retentionDays: z.number().int().positive().nullable(),
});

export type BoardSnapshotRetentionPatch = z.infer<
  typeof boardSnapshotRetentionPatchSchema
>;

export const boardSnapshotCaptureAttachmentsPatchSchema = z.strictObject({
  captureAttachments: z.boolean(),
});

export type BoardSnapshotCaptureAttachmentsPatch = z.infer<
  typeof boardSnapshotCaptureAttachmentsPatchSchema
>;

export const boardSnapshotRestoreBodySchema = z.strictObject({
  title: z.string().trim().min(1).max(512).optional(),
});

export type BoardSnapshotRestoreBody = z.infer<typeof boardSnapshotRestoreBodySchema>;

export const boardSnapshotRestoreResponseSchema = z.strictObject({
  board: boardSchema,
  listsRestored: z.number().int().nonnegative(),
  cardsRestored: z.number().int().nonnegative(),
});

export type BoardSnapshotRestoreResponse = z.infer<
  typeof boardSnapshotRestoreResponseSchema
>;
